import React from 'react'

const CategoryNameContainer = ({ containerObject, templateName, contentId, dataZone }) => {
  return (
    <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row g-0`} >
		<div className='row ose-category-name p-0'>
			<h2 class="right-panel-heading">{containerObject && containerObject.currentCategoryName ? containerObject.currentCategoryName : containerObject.seoName ? containerObject.seoName : ""}</h2>
		</div>
    </div>
  )
}

export default CategoryNameContainer